import React, { useContext } from "react";
import "./forgotpassword.css";
import { FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import TopNavbar from "../../components/TopNavbar/TopNavbar";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";

const ForgotPassword = () => {
  const { language } = useContext(LanguageContext);
  const ta = language === "ta";

  const forgotlabels = {
    emailPhone: ta ? "மின்னஞ்சல் (அ) தொலைபேசி" : "Email or Phone",
    otp: ta ? "OTP அனுப்ப" : "Send OTP",
  };

  return (
    <>
      <TopNavbar />
      <Navbar />
      <div className="forgot-bg">
        <div className="forgot-overlay">
          <div className="forgot-box">
            <h2>Forgot Password</h2>
            <form>
              <label htmlFor="email">
                {forgotlabels.emailPhone}
                <span className="error fs-star">*</span>
              </label>
              <div className="input-group">
                <span className="input-icon">
                  <FaUser />
                </span>
                <input
                  type="text"
                  id="email"
                  placeholder="Enter your email or phone"
                  required
                />
              </div>
              <button type="submit" className="otp-btn">
                {forgotlabels.otp}
              </button>

              <div className="bottom-links">
                <Link to={`/login?lang=${language}`} className="back-login">
                  Back to Login
                </Link>
                <p>
                  Don't have an account?{" "}
                  <Link to={`/register?lang=${language}`} className="crt-ac">
                    Create an account
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgotPassword;
